import React, { Component } from 'react';
import 'react-datetime/css/react-datetime.css';
import API from '../../../utils/API';
import AddPointsModal from './modals/addPointModal';
import RemovePointModal from './modals/removePointModal';
import EditPointsModal from './modals/editPointModal';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import DraggableGrid from '../../../components/grids/DraggableGrid';

class EventInteractionPoints extends Component {
	constructor(props) {
		super(props);

		const columns = {
			iconClass: 'Icon',
			customLabel: 'Label',
			description: 'Description',
			pointValue: 'Value',
			maxPointsAllowed: 'Submission Limit',
			oncePerReference: 'Once Per Reference',
			doNotShow: 'Hidden in App',
			active: 'Active'
		};
		const columnTypes = {
			iconClass: 'icon',
			customLabel: 'string',
			description: 'text',
			pointValue: 'number',
			maxPointsAllowed: 'number',
			oncePerReference: 'boolean',
			doNotShow: 'boolean',
			active: 'boolean',
		};

		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});

		this.state = {
			availablePoints: [],
			allPoints: [],
			points: [],
			removePointModalOpen: false,
			addPointsModalOpen: false,
			editPointModalOpen: false,
			markedPoint: null,
			columns: columns,
			columnTypes: columnTypes,
			normalizedColumns: normalizedColumns,
			toggledColumns: toggledColumns,
			checkedPoints: [],
			interactionPointsOrder: []
		};
	}

	componentDidMount() {
		const { orgId, eventId } = this.props;
		this.props.setSelectedTab(1);

		this.setState({ loading: true });
		API().get(`Organizations/${orgId}/events/${eventId}/interactions`).then((res) => {
			if (res.data) {
				// Get distinct categories from existing points
				const categories = [...new Set(res.data.points.map(point => point.category))].filter(Boolean);
				const categoryOptions = categories.map(category => ({
					label: category,
					value: category
				}));

				const points = res.data.points;
				this.setState({
					points,
					allPoints: res.data.availablePoints,
					availablePoints: res.data.availablePoints,
					categoryOptions: categoryOptions,
					loading: false,
					interactionPointsOrder: res.data.interactionPointsOrder || points.map(point => point._id)
				});
			}
		});
	}

	updateCategoryOptions = (points) => {
		const categories = [...new Set(points.map(point => point.category))].filter(Boolean);
		const categoryOptions = categories.map(category => ({
			label: category,
			value: category
		}));
		return categoryOptions;
	};

	addInteractionPoint = (interactionPoint) => {
		const { points, interactionPointsOrder } = this.state;
		const availablePoints = this.state.availablePoints;
		points.push(interactionPoint);

		// Update category options with the new point
		const categoryOptions = this.updateCategoryOptions(points);

		// Add new point's ID to the end of the order array
		const updatedOrder = [...interactionPointsOrder, interactionPoint._id];

		this.setState({
			points,
			availablePoints,
			categoryOptions,
			interactionPointsOrder: updatedOrder
		});
	};

	toggleRemovePoint = (point) => {
		this.setState({
			removePointModalOpen: !this.state.removePointModalOpen,
			markedPoint: point ? point : null
		});
	};

	toggleEditPoint = (point) => {
		this.setState({
			editPointModalOpen: !this.state.editPointModalOpen,
			markedPoint: point ? point : null
		});
	};

	editPoint = (point) => {
		const points = this.state.points.map((s) => (s._id == point._id ? { ...s, ...point } : s));

		// Update category options with the edited point
		const categoryOptions = this.updateCategoryOptions(points);

		this.setState({
			points: points,
			categoryOptions: categoryOptions
		});
	};

	removePoint = (pointId) => {
		const { points, interactionPointsOrder } = this.state;
		const updatedPoints = points.filter((s) => s._id !== pointId);

		// Update category options after removing point
		const categoryOptions = this.updateCategoryOptions(updatedPoints);

		// Remove the point's ID from the order array
		const updatedOrder = interactionPointsOrder.filter(id => id !== pointId);

		this.setState({
			points: updatedPoints,
			availablePoints: this.state.allPoints,
			categoryOptions,
			interactionPointsOrder: updatedOrder
		});
	};

	updatedCheckedPoints = (checked) => {
		this.setState({ checkedPoints: checked });
	};
	resetCheckedPoints = () => {
		this.setState({ checkedPoints: {} });
	};

	sortData = (column, sortAsc, sortDesc) => {
		const { normalizedColumns } = this.state;
		const updatedColumns = normalizedColumns.map((col) => {
			if (col.key == column.key) {
				col.sortAsc = sortAsc;
				col.sortDesc = sortDesc;
			} else {
				col.sortAsc = false;
				col.sortDesc = false;
			}
			return col;
		});

		this.setState({
			normalizedColumns: updatedColumns,
			selectedColumnSort: column,
			sortDesc: sortDesc ? true : false
		});
	};

	sortPoints = () => {
		const {
			sortDesc,
			selectedColumnSort,
			points,
			interactionPointsOrder
		} = this.state;

		// First order by interactionPointsOrder if it exists
		let pointsData = [...points];
		if (interactionPointsOrder && interactionPointsOrder.length > 0) {
			pointsData.sort((a, b) => {
				const aIndex = interactionPointsOrder.indexOf(a._id);
				const bIndex = interactionPointsOrder.indexOf(b._id);
				// Handle items not in order array
				if (aIndex === -1) return 1;
				if (bIndex === -1) return -1;
				return aIndex - bIndex;
			});
		}

		// Then apply column sorting if selected
		if (selectedColumnSort) {
			pointsData = pointsData.sort((a, b) => {
				const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
				if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
					switch (columnType) {
						case 'string':
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
						case 'number':
							return a[selectedColumnSort.key] - b[selectedColumnSort.key];
						case 'date':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'time':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'boolean':
							const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
							const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
							return a1.localeCompare(b1);
						default:
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
					}
				} else if (a[selectedColumnSort.key]) {
					return 1;
				}
				return -1;
			});

			pointsData = sortDesc ? pointsData.reverse() : pointsData;
		}

		return pointsData;
	}

	render() {
		const { points, addPointsModalOpen, removePointModalOpen, editPointModalOpen, markedPoint,
			normalizedColumns, checkedPoints } = this.state;
		const { sessions } = this.props;
		const sortedpoints = this.sortPoints();
		return (
			<div className="sectionContainer">
				<div className="sectionBody posRel p-0">
					<ActionButtonContainer searchEnabled={false} mainActions={[
						{
							type: 'button',
							label: 'Add interaction point',
							onClick: () => this.setState({ addPointsModalOpen: true })
						}
					]} />
					<DraggableGrid
						data={sortedpoints}
						columns={normalizedColumns}
						title="Virtual Engagement"
						checked={checkedPoints}
						columnWidths={{
							iconClass: '50px',
							customLabel: '200px',
							description: '250px',
							active: '70px'
						}}
						checkRow={(entryId) => {
							const checked = this.state.checkedPoints;
							checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
							this.updatedCheckedPoints(checked);
							this.setState({ checkedPoints: checked });
						}}
						onClick={(entryId) => {
							const markedPoint = this.state.points.find((point) => point._id == entryId);
							this.toggleEditPoint(markedPoint);
						}}
						onOrderChange={(newOrder) => {
							// Store the new order in state
							this.setState({ interactionPointsOrder: newOrder });

							// Update the order on the server
							const { orgId, eventId } = this.props;
							API().patch(`Organizations/${orgId}/events/${eventId}/interactions/points/order`, {
								interactionPointsOrder: newOrder
							});
						}}
					/>
					<ActionButtonContainer
						batchActions={
							[
								{
									type: 'button',
									label: 'Delete Points',
									onClick: this.toggleRemovePoint,
									iconClass: 'las la-trash-alt mr-10',
									class: 'neu danger'
								}
							]}
						checkedEntryCount={Object.keys(checkedPoints).length}
						entriesLength={points.length}
						disableNueFooter={true}
						uncheckEntries={() => {
							this.setState({ checkedPoints: {} });
						}}
					/>
				</div>
				{addPointsModalOpen && (
					<AddPointsModal
						isOpen={addPointsModalOpen}
						toggle={() => this.setState({ addPointsModalOpen: false })}
						availablePoints={this.state.availablePoints}
						eventId={this.props.eventId}
						orgId={this.props.orgId}
						addInteractionPoint={this.addInteractionPoint}
						sessions={sessions}
						attendees={this.props.attendees}
						feeds={this.props.feeds}
						event={this.props.event}
						categoryOptions={this.state.categoryOptions}
					/>
				)}

				{removePointModalOpen && (
					<RemovePointModal
						isOpen={removePointModalOpen}
						toggle={this.toggleRemovePoint}
						eventId={this.props.eventId}
						orgId={this.props.orgId}
						markedPoint={markedPoint}
						points={sortedpoints}
						checkedPoints={Object.keys(checkedPoints)}
						removePoint={this.removePoint}
						resetCheckedPoints={this.resetCheckedPoints}
					/>
				)}

				{editPointModalOpen && (
					<EditPointsModal
						isOpen={editPointModalOpen}
						toggle={this.toggleEditPoint}
						eventId={this.props.eventId}
						orgId={this.props.orgId}
						markedPoint={markedPoint}
						editPoint={this.editPoint}
						sessions={sessions}
						attendees={this.props.attendees}
						feeds={this.props.feeds}
						event={this.props.event}
						categoryOptions={this.state.categoryOptions}
						groups={this.props.groups}

					/>
				)}
			</div>
		);
	}
}

export default EventInteractionPoints;
